import AgentApplicationSuccess from 'pages/Agent/AgentApplicationSuccess';
import React from 'react';
import { Route } from 'react-router-dom';
import Agent from '../pages/Agent';

export const AGENT_SUCCESS_PATH = '/agent/application-success';
/**
 * An array of route configuration objects for agent-related routes.
 * Each object specifies the path and the corresponding component to render.
 *
 * @example
 * // Usage in a router setup
 * AGENT_ROUTE_LISTS.forEach(route => {
 *   <Route path={route.path} element={<route.component />} />
 * });
 *
 * @property {string} path - The URL path for the route.
 * @property {React.ComponentType} component - The React component to render for the route.
 */
const AGENT_ROUTE_LISTS = [
    {
        path: '/agent/:agentId/tenantapplication/:agentLink',
        component: Agent,
    },
    {
        path: AGENT_SUCCESS_PATH,
        component: AgentApplicationSuccess
    }
];


/**
 * An array of React Router <Route> elements generated from the AGENT_ROUTE_LISTS configuration.
 * This array can be directly used within a <Routes> component to define the routing structure.
 *
 * @example
 * // Usage in a router setup
 * <Routes>
 *   {agentRoutes}
 * </Routes>
 */
export const agentRoutes = AGENT_ROUTE_LISTS.map(
    (route: { path: string; component: React.ComponentType }, idx: number) => (
        <Route
            key={route.path || idx}
            path={route.path}
            element={<route.component />}
        />
    )
);
